import { IAutoMapper } from "../interfaces";

export const mapAnalyticsItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "AnalyticsItem")
    .forMember("analyticsItemID", o => o.analyticsItemID)
    .forMember("name", o => o.name)
    .forMember("description", o => o.description)
    .forMember("analyticsType", o => o.analyticsType)
    .forMember("analyticsSource", o => o.analyticsSource)
    .forMember("analyticsCategory", o => o.analyticsCategory)
    .forMember("analyticsOutput", o => o.analyticsOutput)
    .forMember("directoryRoleData", o => o.directoryRoleData)
    .forMember("projectTypeData", o => o.projectTypeData)
    .forMember("url", o => o.url)
    .forMember("lookerIframeUrl", o => o.lookerIframeUrl)
    .forMember("lookerIframeId", o => o.lookerIframeId)
    .forMember("lookerPermissionSet", o => o.lookerPermissionSet)
    .forMember("projectId", o => o.projectId)
   .forMember("organizationList", o => o.organizationList);

};
